import axios from "axios";
import { getToken } from "./auth";

const API_SERVICE = `${process.env.REACT_APP_ENVIRONMENT}` !== 'DEV' ? '/trocasenha-service' : ':8080';
const API_VERSION = '/v1';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_ROOT}${API_SERVICE}${API_VERSION}`
});

api.interceptors.request.use(async config => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;